<template>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="36" rx="8" fill="none" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M13 9.75C12.3096 9.75 11.75 10.3096 11.75 11V25C11.75 25.6904 12.3096 26.25 13 26.25H23C23.6904 26.25 24.25 25.6904 24.25 25V14.8284C24.25 14.4969 24.1183 14.179 23.8839 13.9445L20.0555 10.1161C19.821 9.8817 19.5031 9.75 19.1716 9.75H13ZM10.25 11C10.25 9.48122 11.4812 8.25 13 8.25H19.1716C19.9009 8.25 20.6004 8.53973 21.1161 9.05546L24.9445 12.8839C25.4603 13.3996 25.75 14.0991 25.75 14.8284V25C25.75 26.5188 24.5188 27.75 23 27.75H13C11.4812 27.75 10.25 26.5188 10.25 25V11Z"
              :fill="color" />
        <path d="M19.5 13.5V9L25 14.5H20.5C19.9477 14.5 19.5 14.0523 19.5 13.5Z" :fill="color" />
        <path
            d="M14.5 20.4355C14.5 20.0213 14.8358 19.6855 15.25 19.6855H20.75C21.1642 19.6855 21.5 20.0213 21.5 20.4355C21.5 20.8498 21.1642 21.1855 20.75 21.1855H15.25C14.8358 21.1855 14.5 20.8498 14.5 20.4355Z"
            :fill="color" />
        <path
            d="M18 16.9355C18.4142 16.9355 18.75 17.2713 18.75 17.6855L18.75 23.1855C18.75 23.5998 18.4142 23.9355 18 23.9355C17.5858 23.9355 17.25 23.5998 17.25 23.1855L17.25 17.6855C17.25 17.2713 17.5858 16.9355 18 16.9355Z"
            :fill="color" />
    </svg>

</template>
<script>
export default {
    name: "RoundedLine",
    props: ["color"],
};
</script>



// WEBPACK FOOTER //
// src/components/V2/svg/components/FileIcon.vue